import React from 'react';
import {Layout} from 'antd';
import classNames from 'classnames';
import './index.less';

const BaseContentMain = ({children, className = ''}) => {
  const Cls = classNames('baseContentMain', className);
  return (
    <Layout className={Cls}>
      <div className="innerContent">{children}</div>
    </Layout>
  );
};

export default BaseContentMain;
